import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  reloadTable$ = new BehaviorSubject(false);
  API_SERVER: string = environment.baseApiUrl;

  constructor(
    private httpClient: HttpClient,
    private _t: TranslateService
  ) { }

  private extractData(res: Response | HttpEvent<any>) {
    const body = res;
    return body || {};
  }

  findAll(params?): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient
      .get(this.API_SERVER + 'file', { params: Params })
      .pipe(map(this.extractData));
  }

  findOne(id): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + `file/${id}`)
      .pipe(map(this.extractData));
  }

  create(data, opts?: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Origin', '*');
    opts = { ...opts, ...headers }

    return this.httpClient.post<any>(this.API_SERVER + 'file', data, opts).pipe(
      map(res => this.extractData(res))
    )
  }

  uploadMeta(data, opts?: any): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Origin', '*');
    opts = { ...opts, ...headers }

    return this.httpClient.post<any>(this.API_SERVER + 'metadata', data, opts).pipe(
      map(res => this.extractData(res))
    )
  }

  updateKonva(id, data): Observable<any> {
    return this.httpClient
      .put(this.API_SERVER + `file/${id}/update-konva-annotations`, data)
      .pipe(map(this.extractData));
  }

  update(id, data): Observable<any> {
    return this.httpClient
      .put(this.API_SERVER + `file/${id}`, data)
      .pipe(map(this.extractData));
  }

  remove(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `file/${id}`)
      .pipe(map(this.extractData));
  }

  removeMany(id: string[]): Observable<any> {
    return this.httpClient
      .post(this.API_SERVER + `file/delete-many`, id)
      .pipe(map(this.extractData));
  }

  restore(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `file/restore/${id}`)
      .pipe(map(this.extractData));
  }

  /**
   * Method is used to download file from blob/binary.
   * @param data - Array Buffer data
   * @param type - type of the document.
   * Taken from https://stackoverflow.com/a/51682664
   */
  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type });
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert(this._t.instant('Please disable your Pop-up blocker and try again.'));
    }
  }

  simulateDownloadClick(url, format?: string) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);

    const split = url.split('/')
      , name = split[split.length - 1];

    link.setAttribute('download', name + (format || ''));
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  /** Opens new URL */
  openNewTab(url: string) {
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert(this._t.instant('Please disable your Pop-up blocker and try again.'));
    }
  }
}
